import { AsyncPipe, LowerCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CategoryDirective } from '@app/core/directives/category.directive';
import { List } from '@app/core/interfaces/list';
import { PricingFilterValues } from '@app/pages/gallery/pricing-filter/pricing-filter-values';
import { ListingsSelectors } from '@app/store';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-free-images',
  templateUrl: './free-images.component.html',
  styleUrls: ['./free-images.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, LowerCasePipe, CategoryDirective],
})
export class FreeImagesComponent {
  categories$: Observable<List | undefined> = inject(Store).select(
    ListingsSelectors.categories,
  );

  protected PricingFilterValues = PricingFilterValues;
}
